// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__R4IIs","bigColWidth":"Table_bigColWidth__NJx0J","biggerColWidth":"Table_biggerColWidth__3Hwx0","row":"Table_row__3-0w_","col":"Table_col__275Va"};